<template>
  <div>
    <transition name="slide-fade-down">
      <b-img
        :src="require('@/assets/images/logo_centered.svg')"
        width="300"
        class="rounded-0"
        v-show="show"
      />
    </transition>

    <div class="mt-5">
      <h4 class="font-weight-bold">Create Your Account</h4>
      <!-- <p class="mt-3">
        Lorem ipsum dolor sit amet, consetetur sadipscing elitr
      </p> -->
    </div>

    <b-form class="mt-4" @submit.prevent="onSignup">
      <b-form-group id="input-group-1" class="col-12">
        <i class="clearable" v-show="form.email" @click="form.email = ''"
          >&times;</i
        >
        <b-form-input
          id="input-1"
          v-model="form.email"
          type="email"
          class="input-effect"
          :class="form.email ? 'has-content' : ''"
          required
          autofocus
        ></b-form-input>
        <label>Email address</label>

        <div class="input-error" v-if="form.$getError('email')">
          {{ form.$getError('email')[0] }}
        </div>
      </b-form-group>

      <b-form-group id="input-group-2" class="col-12">
        <i class="clearable encryptable" v-show="form.password">
          <b-icon
            scale="0.5"
            icon="eye-slash-fill"
            v-if="showPassword"
            @click="showPassword = false"
          ></b-icon>
          <b-icon
            scale="0.5"
            icon="eye-fill"
            v-else
            @click="showPassword = true"
          ></b-icon>
        </i>
        <b-form-input
          id="input-2"
          v-model="form.password"
          class="input-effect"
          :class="form.password ? 'has-content' : ''"
          :type="showPassword ? 'text' : 'password'"
          autocomplete="new-password"
          required
        ></b-form-input>
        <label>Password</label>

        <div class="input-error" v-if="form.$getError('password')">
          {{ form.$getError('password')[0] }}
        </div>
      </b-form-group>

      <b-button class="mt-4" type="submit" variant="primary" block>
        <b-spinner class="mr-2" small v-if="form.$busy" />Next
      </b-button>

      <div class="mt-4">
        Have an account?
        <b-link class="form-link" :to="{ name: 'auth.login-page' }"
          >Login</b-link
        >
      </div>

      <div class="mt-3">
        By logging in, you accept to Schedulized’s
        <br />
        <b-link
          class="form-link"
          :to="{ name: 'terms-of-service' }"
          target="_blank"
          >Terms of Service</b-link
        >&nbsp;&
        <b-link
          class="form-link"
          :to="{ name: 'privacy-policy' }"
          target="_blank"
          >Privacy Policy</b-link
        >.
      </div>
      <div class="mt-5">
        Got questions? See
        <b-link
          class="form-link"
          target="_blank"
          :to="{ name: 'frequently-asked-questions' }"
          >FAQs</b-link
        >
      </div>
    </b-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Form from '@/utils/form'

export default {
  data() {
    return {
      show: false,
      showPassword: false,
      form: new Form({
        email: '',
        password: '',
        password_confirmation: ''
      })
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  methods: {
    validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },

    async onSignup(evt) {
      if (this.validateEmail(this.form.email)) {
        this.form.$busy = true
        this.form.password_confirmation = this.form.password
        await this.$api
          .post('auth/register', this.form.$data())
          .then(({ data }) => {
            this.form.$busy = false
            this.$store.commit('auth/setToken', data.data)
            this.$store.commit('auth/setUser', data.data.user)
            this.$router.replace({
              name: 'auth.verify-page',
              params: { account: 'email' }
            })
          })
          .catch(error => {
            this.form.$handleError(error)
          })
      } else {
        this.form.$setErrors({ email: ['The email address is invalid.'] })
      }
    }
  },

  mounted() {
    this.show = true
  },

  watch: {
    '$route.query.email': {
      handler(value) {
        this.form.email = value
      },
      immediate: true
    },
    'form.email'() {
      this.form.$clearError('email')
    },
    'form.password'() {
      this.form.$clearError('password')
    }
  }
}
</script>

<style lang="scss" scoped>
.form-link {
  font-weight: bold;
}
.encryptable {
  right: 8px;
}
</style>
